var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "psychological-month-report" },
    [
      _c("ReportHeader", {
        attrs: {
          schoolName: _vm.schoolName,
          exportPdfLoading: _vm.exportPdfLoading,
        },
        on: { exportReport: _vm.exportReportPdf, changeMonth: _vm.changeMonth },
      }),
      _c("div", { staticStyle: { height: "90px" } }),
      _c(
        "div",
        { ref: "monthReportMainBody", staticClass: "main-body" },
        [
          _c("CurrMonthOverview", {
            attrs: {
              dateRange: _vm.dateRange,
              faceCollectInfo: _vm.faceCollectInfo,
              schoolName: _vm.schoolName,
              dataSource: _vm.currMonthOverviewObj,
            },
          }),
          _c("CameraAcquisition", {
            staticStyle: { "margin-top": "30px" },
            attrs: {
              dateRange: _vm.dateRange,
              dataSource: _vm.cameraAcquisitionObj,
            },
          }),
          _c("SentimentAnalysis", {
            staticStyle: { "margin-top": "30px" },
            attrs: { dateRange: _vm.dateRange },
          }),
          _c("RemindListTrend", {
            staticStyle: { "margin-top": "30px" },
            attrs: { dateRange: _vm.dateRange },
          }),
          _c("MainStudentManagement", {
            staticStyle: { "margin-top": "30px" },
            attrs: {
              dateRange: _vm.dateRange,
              currMonthInfo: _vm.currMonthInfo,
              cardInfo: _vm.mainStudentCardInfo,
            },
          }),
          _c("RemindCaringSituation", {
            staticStyle: { "margin-top": "30px" },
            attrs: {
              dateRange: _vm.dateRange,
              dataSourceExtra: _vm.remindCaringExtra,
            },
          }),
          _c("TeacherUseData", {
            staticStyle: { "margin-top": "30px" },
            attrs: {
              dateRange: _vm.dateRange,
              overallUsageInfo: _vm.overallUsageInfo,
            },
          }),
          _c("PsychologicalTeachersUse", {
            ref: "psychologicalTeachersUseRef",
            staticStyle: { "margin-top": "30px" },
            attrs: {
              dateRange: _vm.dateRange,
              coachingCoreInfo: _vm.coachingCoreInfo,
              faceCollectInfo: _vm.faceCollectInfo,
            },
          }),
          _c("WholeSchoolEmotionAnalysis", {
            staticStyle: { "margin-top": "30px" },
            attrs: { dateRange: _vm.dateRange },
          }),
        ],
        1
      ),
      _c("a-back-top", {
        attrs: { target: _vm.targetFn, visibilityHeight: 400 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }